// TOP: この契約で使用可能なサービス（portal.md「TOP」）。リンクは serviceUrl をそのまま開く（portal.md「サービスへの遷移」）。
// member・admin には自分が使えるサービスだけを出す（契約の全体はサービス利用画面で見る）。
// system-admin には契約のサービス利用（有効なもの）を出す（所属が無くても見える）。

import { useEffect, useState } from "react";
import { api, messageFor, type ContractRows } from "../lib/api";
import { serviceLabel } from "./shared";
import { useContract } from "./ContractLayout";

interface Row { subsystem: string; serviceUrl: string }

export function TopPage() {
  const { me, membership, contractId } = useContract();
  const sysadmin = me.platformRole === "system-admin";
  const [rows, setRows] = useState<ContractRows | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!sysadmin) return;
    api.contract(contractId).then(setRows).catch((e) => setError(messageFor(e)));
  }, [contractId, sysadmin]);

  if (sysadmin && !rows) return <main>{error ? <p className="error">{error}</p> : <p className="muted">読み込み中…</p>}</main>;

  const contractName = rows?.contract.name ?? membership?.contract.name ?? contractId;
  const services: Row[] = sysadmin
    ? rows!.subscriptions.filter((c) => c.subscriptionActive).map((c) => ({ subsystem: c.subsystem, serviceUrl: c.serviceUrl }))
    : (membership?.services ?? []).filter((s) => s.enabled).map((s) => ({ subsystem: s.subsystem, serviceUrl: s.serviceUrl }));

  return (
    <main>
      <h1>使用可能なサービス</h1>
      {sysadmin && <p className="muted">この契約のサービス利用が有効なサービスです（システム管理者として閲覧中）。</p>}
      {services.length === 0 && <p className="muted">使用可能なサービスがありません。</p>}
      <div className="grid">
        {services.map((s) => (
          <div key={s.subsystem} className="card">
            <div className="row"><strong>{serviceLabel(s.subsystem, contractName)}</strong></div>
            <p className="muted">{s.serviceUrl}</p>
            <a className="btn" href={s.serviceUrl}>開く</a>
          </div>
        ))}
      </div>
    </main>
  );
}
